var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"footer":_vm.footer,"config":_vm.config},scopedSlots:_vm._u([{key:"STATUS",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Tracker',{attrs:{"statusId":params.airway_number}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }